/*
==== ListSort JavaScript Directive ====

Notes:
* As an admin, I want to be able to sort the list based on any relevant data displayed in list
* As an Admin, I want to be able to sort the employee list based on any of the values displayed on the employee list
* Display the selected option when the sorting dropdown is closed
* When viewing the sorting options, display an icon on the selected options
* Highlight the

How to implement the listSort:
<section listSort="sortListConfig"></section>
<script type="text/javascript" src="${jsCdnHost}/__assets__/stylekit/js/jv.SortList.js?v=${fileVersion}"></script>


var sortListConfig = {
    actionTitle: 'Sort By',
    message: 'Please select an action', // Used to display errors
    sortOptions: [
        {
            value: 'First Name',
            id: 'fname' // for automation, id will be `sort-list-option-fname`
        },
        {
            value: 'Last Name',
            id: 'lname'
        },
        {
            value: 'Invite Status',
            id: 'status'
        }
    ],
    sortOrder: [
        {
            value: 'ASC'
        },
        {
            value: 'DSC'
        }],
    selectedOption: 0,
    selectedSortOrder: 1
};

Sort Options:
* Based on an array list
* Have N' number of groups for sorting options, based on the array(s) provided
* Options in the arrays need to be values in the list for the columns
*/

angular.module('jv.Common.Directives.SortList', [])
.run(['sortListScopesService', function(sortListScopesService) {
    // Close all sort lists when you click on the body
    $('body').on('click', function(event) {
        var target = event.target;
        var scope = !angular.isUndefined($(target).scope) ? $(target).scope() : null;

        if (!$(target).parent('section[sortlist] button')) {
            sortListScopesService.hideSortListOptions();
        } else {
            // Hide other sortList items
            scope && sortListScopesService.hideSortListOptions(scope);
        }
    });
}])
.service('sortListScopesService', ['$timeout', function($timeout) {
    var sortListScopes = [];

    this.addScope = function(scope) {
        sortListScopes.push(scope);
    };

    this.hideSortListOptions = function(scopeToSkip) {
        $timeout(function(){
            var i;
            for (i = 0; i < sortListScopes.length; i++) {
                if (sortListScopes[i].$id !== (scopeToSkip && scopeToSkip.$id)) {
                    sortListScopes[i].optionsListOpen = false;
                }
            }
        });
    }
}])
.controller('sortListController', ['$scope', 'sortListScopesService', function($scope, sortListScopesService) {
    $scope.optionsListOpen = false;

    // Store all references to the sortListScopes
    sortListScopesService.addScope($scope);

    // Clear the message / error value when the action options is closed
    $scope.$watch('optionsListOpen', function(newValue, oldValue) {
        if (newValue) {
            $scope.sortlist.message = [];
        }
    });

    // Change the selected option based on the users input
    $scope.changeSortOption = function(index) {
        $scope.optionsListOpen = !$scope.optionsListOpen;
        $scope.sortlist.selectedOption = index;
    };

    $scope.toggleSortOptions = function() {
        $scope.optionsListOpen = !$scope.optionsListOpen;
    };

    // Change the selected sort order based on the users input
    $scope.changeSortOrder = function(index) {
        $scope.optionsListOpen = !$scope.optionsListOpen;
        $scope.sortlist.selectedSortOrder = index;
    };
}])
.directive('sortlist', [function() {
    return {
        restrict: 'A',
        scope: {
            sortlist: '='
        },
        templateUrl: '/__assets__/stylekit/templates/sortlist.html'
    };
}]);
